import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutLogosQuoteBlock = {
  factory: EElement({
    id: '1d7c5d92-9016-b9f7-1cca-4a77169e191e',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('d80631d0-ebd9-e477-c3e8-04fd46ee3c92')]),
      children: EList([
        EElement({
          id: '1d7c5d92-9016-b9f7-1cca-4a77169e191f',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '08dd75e7-e303-c839-ee37-14c6a51a6880',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('b20d31c3-fb88-d10e-9f56-6399b14d6223'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'c7c80a84-d3ee-b0a5-de76-1dcd4b524ce4',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('43acb02f-9d90-c16d-6cbd-b8b9e5e566da'),
                        ]),
                        children: EList([
                          EElement({
                            id: '0dea635d-ae26-aff9-bf6f-1deb13b7760d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('657478fa-5ae5-5dbe-07bb-ab1161c7000b'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0dea635d-ae26-aff9-bf6f-1deb13b7760e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CAliquet consectetur id magna ac integer. Aliquet consectetur id magna ac integer.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '0375ddef-45f5-8f07-957e-ac6c8f0dfcf1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('54eef58b-c367-38bb-7b13-fe77a5df05be'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '654eacec-8fb2-c701-080a-361829c7c9ac',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageCards),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"627308a8eb8c0699ea59a236"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '4e99ed88-910f-dd8c-a678-d046d4ea30a9'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '2fb076d3-17c2-97db-edf3-7add7960df6f',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: '2fb076d3-17c2-97db-edf3-7add7960df70',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Full Name, Title'),
                                      }),
                                      EElement({
                                        id: '866219b8-dbf3-0ce4-527d-52e7735debc4',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('LineBreak')
                                        ),
                                        data: ERecord({}),
                                      }),
                                      EElement({
                                        id: '94c67ba2-2bc7-a39d-8539-f96f0af45cab',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Company'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'b3f142b2-7a18-7cb4-e886-1da1581360f7',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('c70f2bf7-3213-d366-badb-afa71983ae44'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'dfe76fa6-5bd7-fab7-f9c4-b0b91fbb6379',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.ephicientLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('Ephicient logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627308a8eb8c0699ea59a262"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'd1a5d368-0157-eb06-456b-ce5893a4b22c',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.twentyLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('OE logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627308a8eb8c0699ea59a267"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '0ef40e06-2702-d3dd-d3a1-443642278ba8',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.pipelinxLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('2020INC logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627308a8eb8c0699ea59a263"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '14c072fa-67d7-0ba4-20fa-fc1398eb9a37',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.oeLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('The Paak logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                  medium: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627308a8eb8c0699ea59a256"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'caeea361-ad8d-1b38-f19f-55cb955f17e6',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.thePaakLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('Pipelinx.co logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627308a8eb8c0699ea59a266"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '82f2e53a-15e2-aa13-411c-36d1be61b0df',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.ariseHealthLogo),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('AriseHealth logo'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"627308a8eb8c0699ea59a258"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('96521aa5-d56e-644a-ce5e-e9732f052992'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'd80631d0-ebd9-e477-c3e8-04fd46ee3c92',
      type: 'class',
      name: 'Logos Quote Block',
      comb: '',
      styleLess:
        'position: relative; padding-top: 60px; padding-right: 30px; padding-bottom: 60px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'b20d31c3-fb88-d10e-9f56-6399b14d6223',
      type: 'class',
      name: 'Clients Wrapper Two',
      comb: '',
      styleLess:
        'display: flex; max-width: 820px; margin-right: auto; margin-left: auto; justify-content: space-between; align-items: center;',
      children: [],
      variants: {small: {styleLess: 'flex-direction: column;'}},
    },
    {
      _id: '43acb02f-9d90-c16d-6cbd-b8b9e5e566da',
      type: 'class',
      name: 'Clients Card',
      comb: '',
      styleLess:
        'display: flex; width: 50%; padding-top: 24px; padding-right: 24px; padding-bottom: 24px; padding-left: 24px; flex-direction: column; align-items: flex-start; background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {small: {styleLess: 'width: 100%; margin-bottom: 30px;'}},
    },
    {
      _id: '657478fa-5ae5-5dbe-07bb-ab1161c7000b',
      type: 'class',
      name: 'Clients Quote',
      comb: '',
      styleLess:
        'margin-bottom: 24px; font-size: 24px; line-height: 32px; font-weight: 600;',
      children: [],
      variants: {tiny: {styleLess: 'font-size: 20px; line-height: 28px;'}},
    },
    {
      _id: '54eef58b-c367-38bb-7b13-fe77a5df05be',
      type: 'class',
      name: 'Clients Info',
      comb: '',
      styleLess:
        'display: flex; align-items: center; font-size: 14px; line-height: 20px;',
      children: [],
      variants: {},
    },
    {
      _id: '4e99ed88-910f-dd8c-a678-d046d4ea30a9',
      type: 'class',
      name: 'Clients Info Image',
      comb: '',
      styleLess:
        'width: 50px; height: 50px; margin-right: 24px; object-fit: cover;',
      children: [],
      variants: {tiny: {styleLess: 'margin-right: 16px;'}},
    },
    {
      _id: 'c70f2bf7-3213-d366-badb-afa71983ae44',
      type: 'class',
      name: 'Clients Grid',
      comb: '',
      styleLess:
        'display: grid; justify-items: center; align-items: center; grid-auto-columns: 1fr; grid-column-gap: 50px; grid-row-gap: 50px; grid-template-columns: 1fr 1fr; grid-template-rows: auto auto;',
      children: [],
      variants: {
        small: {
          styleLess:
            'margin-top: 15px; grid-column-gap: 40px; grid-template-columns: 1fr 1fr 1fr;',
        },
        tiny: {
          styleLess:
            'grid-column-gap: 20px; grid-row-gap: 40px; grid-template-columns: 1fr 1fr;',
        },
      },
    },
    {
      _id: '96521aa5-d56e-644a-ce5e-e9732f052992',
      type: 'class',
      name: 'Clients Image Two',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
  ],
} as const;
